var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 2H3.5C3.224 2 3 2.224 3 2.5C3 2.776 3.224 3 3.5 3H22V20C22 20.5515 21.5515 21 21 21H3C2.4485 21 2 20.5515 2 20V5H20V18.5C20 18.7765 20.224 19 20.5 19C20.776 19 21 18.7765 21 18.5V4.5C21 4.224 20.776 4 20.5 4H1.5C1.224 4 1 4.224 1 4.5V20C1 21.103 1.897 22 3 22H21C22.103 22 23 21.103 23 20V2.5C23 2.224 22.776 2 22.5 2Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.5C18 7.224 17.776 7 17.5 7H4.5C4.224 7 4 7.224 4 7.5V9.5C4 9.776 4.224 10 4.5 10H17.5C17.776 10 18 9.776 18 9.5V7.5ZM17 9H5V8H17V9Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12.5C18 12.224 17.776 12 17.5 12H12.5C12.224 12 12 12.224 12 12.5V16.5C12 16.7765 12.224 17 12.5 17H17.5C17.776 17 18 16.7765 18 16.5V12.5ZM17 16H13V13H17V16Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 12H4.5C4.224 12 4 12.224 4 12.5C4 12.7765 4.224 13 4.5 13H9.5C9.776 13 10 12.7765 10 12.5C10 12.224 9.776 12 9.5 12Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 16H4.5C4.224 16 4 16.2235 4 16.5C4 16.7765 4.224 17 4.5 17H9.5C9.776 17 10 16.7765 10 16.5C10 16.2235 9.776 16 9.5 16Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 14H4.5C4.224 14 4 14.2235 4 14.5C4 14.7765 4.224 15 4.5 15H9.5C9.776 15 10 14.7765 10 14.5C10 14.2235 9.776 14 9.5 14Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 18H4.5C4.224 18 4 18.2235 4 18.5C4 18.7765 4.224 19 4.5 19H9.5C9.776 19 10 18.7765 10 18.5C10 18.2235 9.776 18 9.5 18Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 18H12.5C12.224 18 12 18.2235 12 18.5C12 18.7765 12.224 19 12.5 19H17.5C17.776 19 18 18.7765 18 18.5C18 18.2235 17.776 18 17.5 18Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsIcon);
export default __webpack_public_path__ + "static/media/insights-icon.24d36697409509f89eb12d8871e15ff4.svg";
export { ForwardRef as ReactComponent };